import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

window.addEventListener('DOMContentLoaded', () => {
    Swiper.use([Navigation]);

    const blogTeaserSliderContainers = document.querySelectorAll(
        '.swiper-container.blog-teaser-slider',
    );

    blogTeaserSliderContainers.forEach((blogTeaserSliderContainer) => {
        const swiperID = blogTeaserSliderContainer.parentElement.getAttribute('data-swiperid');

        new Swiper(blogTeaserSliderContainer, {
            modules: [Navigation],
            speed: 400,
            direction: 'horizontal',
            spaceBetween: 32,
            slidesPerView: 1,
            roundLengths: true,
            navigation: {
                nextEl: blogTeaserSliderContainer.querySelector('.swiper-button-next'),
                prevEl: blogTeaserSliderContainer.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 3,
                },
            },
        });
    });
});
